import { NOTIFICATION_DISPLAY } from "@/components/common/Notification/notifications";
import { NotificationEventId } from "@/components/common/Notification/notifications.types";

const notificationsToHIde = ["Success", "Error", "Bid Turned Down"];
export interface EventIdsByTextMessage {
  [text: string]: NotificationEventId[];
}

export const getNotificationDisplay = (eventId: NotificationEventId) => {
  return NOTIFICATION_DISPLAY[eventId];
};

export const getEventIdsByMessageType = () => {
  // Adding New bid and Message so that they come on top in the list.
  const eventIdsByText: EventIdsByTextMessage = {
    "New bid": [],
    Message: [],
  };
  Object.keys(NOTIFICATION_DISPLAY).forEach((eventId) => {
    const _eventId = eventId as NotificationEventId;
    const { text } = getNotificationDisplay(_eventId);
    if (!notificationsToHIde.includes(text)) {
      if (!eventIdsByText[text]) {
        eventIdsByText[text] = [];
      }
      eventIdsByText[text].push(_eventId);
    }
  });
  return eventIdsByText;
};
